var _defs, _rect, _path, _path2, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVbSizefitIllustrations21(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 272.3 307.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        stroke: #231f20;\n      }\n\n      .st0, .st1 {\n        fill: none;\n        stroke-miterlimit: 10;\n      }\n\n      .st1 {\n        stroke: #ed1c24;\n        stroke-dasharray: 1;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 0.5,
    y: 0.5,
    width: 271.3,
    height: 306.86
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.25,18.78c-6.07,25.9.42,53.11,7.28,80.6,4.39,17.78,8.96,35.66,10.36,53.39,3.97,49.47-32.67,85.55-35,133.34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M156.19,18.78c6.91,15.21,14.28,30.06,22.22,45.18,3.08,5.88,3.69,12.46,3.97,19.09.28,6.02-1.91,11.53-5.04,16.33-1.26,1.87-2.66,3.64-4.11,5.32-9.33,10.78-5.04,18.44-6.3,27.86-2.19,16.05-1.96,32.48.79,48.44,2.99,17.69,7.79,32.81,6.39,51.2-1.31,16.99-2.75,33.79-1.54,50.82"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 203.62,
    y1: 142.85,
    x2: 203.62,
    y2: 228.65
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVbSizefitIllustrations21);
export default __webpack_public_path__ + "static/media/VB_SIZE&FIT_ILLUSTRATIONS-21.039aff8c99f18c4498d7907f3e7a8bf4.svg";
export { ForwardRef as ReactComponent };